module.exports = __webpack_public_path__ + "img/square-arrow-down.eb9fde0f.svg";